import React from 'react';
import './style.css';

const SearchInput = ({ id, placeholder, onChange, className }) => {
    return (
        <div className="search-input-container">
            <input
                id={id}
                placeholder={placeholder}
                onChange={onChange}
                className={className}
            />
        </div>
    );
};

export default SearchInput;
